var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalWaterUsage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "url(#paint0_linear_5070_17874)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4952 23.8057L33.9926 26.303L35.7602 24.5354V17.4648H28.6896L26.922 19.2324L28.9201 21.2306L29.412 21.7225L25.816 25.3185L21.635 21.1376L20.5934 20.096L19.5518 21.1376L12.2402 28.4491L14.3234 30.5324L20.5934 24.2624L24.7744 28.4433L25.816 29.4849L26.8575 28.4433L31.4952 23.8057Z",
    fill: "url(#paint1_linear_5070_17874)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5070_17874",
    x1: 0,
    y1: 0,
    x2: 48,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53CFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5070_17874",
    x1: 24.0002,
    y1: 17.4648,
    x2: 24.0002,
    y2: 30.5324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalWaterUsage);
export default __webpack_public_path__ + "static/media/total-water-usage.e74394cffee6174657f212f936a8aefa.svg";
export { ForwardRef as ReactComponent };